export default __webpack_public_path__ + "static/media/vnu-hcm.4cb1cd50.png";